import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { CountryModule } from '@platform-frontend/marketplace';
import { PollingModule } from '@platform-frontend/platform';
import { NgxMaskModule } from 'ngx-mask';

import {
  ButtonModule,
  CommonWordingModule,
  FormsModule,
  IconsModule,
  LinkModule,
  LoadingIndicatorModule,
  TabSelectableModule,
  TemplateVariablesModule,
  TooltipModule,
  icoAddCreditCard,
  icoAddCreditCardDuo,
  icoAddCreditCardDuoOutline,
  icoAddDirectDebit,
  icoAddDirectDebitDuo,
  icoAddDirectDebitDuoOutline,
  icoAmexBranded,
  icoApplePay,
  icoApplePayCard,
  icoChevronRight,
  icoCogDuo,
  icoCreditCardValidatorError,
  icoCreditCardValidatorNeutral,
  icoDeleteDuo,
  icoEditFieldDuo,
  icoGooglePay,
  icoGooglePayCard,
  icoInfoDuo,
  icoMastercardBranded,
  icoPaypalBranded,
  icoPaypalBrandedDuo,
  icoPaypalBrandedDuoOutline,
  icoSepa,
  icoTickCircleDuo,
  icoUserGroup,
  icoVisaBranded,
  icoWarningDuo
} from '@platform-frontend/ui-tools';
import { RouterExtensionsModule } from '@platform-frontend/util';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { CheckoutCountryModule } from '../country';
import { DrawDialogModule } from '../draw-dialog';
import { AddNewPaymentMethodButtonComponent } from './add-new-payment-method-button/add-new-payment-method-button.component';
import { AddNewPaymentMethodComponent } from './add-new-payment-method/add-new-payment-method.component';
import { AddPaymentMethodTypeIconPipe } from './add-payment-method-type-icon.pipe';
import { CardTypeDescriptionPipe } from './card-type-description.pipe';
import { CardTypeIconPipe } from './card-type-icon.pipe';
import { CommonPaymentWordingPipe } from './common-payment-wording.pipe';
import { CreditCardFormComponent } from './credit-card-form/credit-card-form.component';
import { DirectDebitFormComponent } from './direct-debit-form/direct-debit-form.component';
import { IbanPipe } from './iban.pipe';
import { PaymentMethodPanelComponent } from './payment-method-panel/payment-method-panel.component';
import { PaymentMethodPollingUiComponent } from './payment-method-polling-ui/payment-method-polling-ui.component';
import { PaymentMethodTypeWordingPipe } from './payment-method-type-wording.pipe';

@NgModule({
  declarations: [
    AddNewPaymentMethodComponent,
    AddNewPaymentMethodButtonComponent,
    CardTypeIconPipe,
    CardTypeDescriptionPipe,
    CommonPaymentWordingPipe,
    CreditCardFormComponent,
    DirectDebitFormComponent,
    IbanPipe,
    PaymentMethodPanelComponent,
    PaymentMethodPollingUiComponent,
    AddPaymentMethodTypeIconPipe,
    PaymentMethodTypeWordingPipe
  ],
  imports: [
    ButtonModule,
    CheckoutCountryModule,
    CommonModule,
    CommonWordingModule,
    CountryModule,
    FormsModule,
    IconsModule.withIcons(
      icoAddCreditCard,
      icoAddCreditCardDuo,
      icoAddCreditCardDuoOutline,
      icoAddDirectDebit,
      icoAddDirectDebitDuo,
      icoAddDirectDebitDuoOutline,
      icoAmexBranded,
      icoApplePay,
      icoApplePayCard,
      icoCogDuo,
      icoChevronRight,
      icoCreditCardValidatorNeutral,
      icoCreditCardValidatorError,
      icoDeleteDuo,
      icoEditFieldDuo,
      icoGooglePay,
      icoGooglePayCard,
      icoInfoDuo,
      icoMastercardBranded,
      icoPaypalBranded,
      icoPaypalBrandedDuo,
      icoPaypalBrandedDuoOutline,
      icoTickCircleDuo,
      icoUserGroup,
      icoVisaBranded,
      icoWarningDuo,
      icoSepa
    ),
    LinkModule,
    LoadingIndicatorModule,
    MatomoTrackClickDirective,
    NgxMaskModule.forChild(),
    PollingModule,
    ReactiveFormsModule,
    RouterExtensionsModule,
    RouterModule,
    TabSelectableModule,
    TemplateVariablesModule,
    TooltipModule,
    TranslocoLocaleModule,
    TranslocoMarkupModule,
    TranslocoModule,
    DrawDialogModule
  ],
  exports: [
    AddNewPaymentMethodComponent,
    AddNewPaymentMethodButtonComponent,
    CardTypeDescriptionPipe,
    CommonPaymentWordingPipe,
    CreditCardFormComponent,
    DirectDebitFormComponent,
    PaymentMethodPanelComponent,
    PaymentMethodPollingUiComponent,
    AddPaymentMethodTypeIconPipe,
    PaymentMethodTypeWordingPipe
  ],
  providers: [CommonPaymentWordingPipe]
})
export class CheckoutPaymentInformationModule {}
